import { useState } from "react";
import Select from "components/ui/Select";
import { useChangeAgttp } from "http-hooks/agttp/useAgttp";
import useAuth from "hooks/useAuth";

const agttpOptions = [
  { value: 0, label: "Agent" },
  { value: 1, label: "Trader" },
];

export default function SetAgttp({ onClose }) {
  // Get current user type from auth
  const { agttp, updateUserType, setToken } = useAuth();
  
  // Find the current option and preselect it
  const currentOption = agttpOptions.find(option => option.value === agttp);
  const [selectedAgttp, setSelectedAgttp] = useState(currentOption || null);

  const { mutateAsync: mutateChange, isLoading: isChanging } = useChangeAgttp();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedAgttp?.value === undefined) {
      return;
    }
    
    try {
      const data = await mutateChange(selectedAgttp.value);
      setToken(data.token);
      updateUserType(data);
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Failed to change agttp:", error);
    }
  };

  const isFormValid = selectedAgttp?.value !== undefined;

  return (
    <form onSubmit={handleSubmit}>
      <div className="space-y-2">
        <h2 className="text-base font-semibold leading-7 text-gray-900">
          Change User Type
        </h2>
        <p className="mt-1 text-sm leading-6 text-gray-600">
          Select your preferred user type below
        </p>

        <div className="space-y-4">
          <div className="mb-24">
            <Select
              options={agttpOptions}
              value={selectedAgttp}
              onChange={setSelectedAgttp}
              label="New User Type"
              placeholder="Select user type..."
              isRequired={true}
              isClearable={false}
              isSearchable={false}
            />
          </div>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-end gap-x-6">
        <button
          type="button"
          className="text-sm font-semibold leading-6 text-gray-900 hover:text-gray-700"
          onClick={onClose}
          disabled={isChanging}
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={!isFormValid || isChanging}
          className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isChanging ? "Changing..." : "Change User Type"}
        </button>
      </div>
    </form>
  );
}
 